export const X1StyleXDefaultTheme = {
  "nav-bar-background": "#FFFFFF",
  wash: "#F0F2F5",
  "web-wash": "#F0F2F5",
  "primary-text": "#050505",
  "primary-accent": "#0866FF",
  "border-line": "#CED0D4",
  "card-corner-radius": "24px",
  "media-inner-border": "rgba(0, 0, 0, 0.05)",
  divider: "#CED0D4",
  "primary-gradient":
    "linear-gradient(135deg, #0866FF 0%, #00B4D8 50%, #0866FF 100%)",
  "secondary-gradient": "linear-gradient(135deg, #007CF0 0%, #00DFD8 100%)",
  "bg-gradient":
    "radial-gradient(circle at 50% 0%, rgba(121, 40, 202, 0.15), transparent 70%), radial-gradient(circle at 100% 0%, rgba(255, 0, 128, 0.1), transparent 50%)",
  "surface-glass": "rgba(255, 255, 255, 0.1)",
  "surface-glass-strong": "rgba(255, 255, 255, 0.8)",
  "shadow-sm":
    "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  "shadow-md":
    "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  "shadow-lg":
    "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "shadow-neon": "0 0 20px rgba(121, 40, 202, 0.3)",
  "glow-border": "rgba(255, 255, 255, 0.5)",
  "text-secondary": "#65676B",
  "timeline-line-bg": "linear-gradient(135deg, #0866FF 0%, #00B4D8 100%)",
  "timeline-dot-shadow": "0 0 15px rgba(8, 102, 255, 0.5)",
  "profile-border": "rgba(255, 255, 255, 0.8)",
  "profile-shadow": "0 8px 32px rgba(8, 102, 255, 0.15)",
  "loading-border-color": "#0866FF",
};
